import React from 'react';
import { Link } from 'react-router-dom';
import FeaturePage from './features/FeaturePage';
import landingPages from '../data/landingPages';
import blogPosts from '../data/blogPosts';
import { formationPages, formationsHub } from '../data/formations';

// Vertical pitch with the formation's lines, goalkeeper at the bottom.
const FormationPitch = ({ shape }) => {
  const rows = shape.split('-').map(Number);
  const rowY = (i) => 215 - (i * 175) / Math.max(rows.length - 1, 1);
  return (
    <svg viewBox="0 0 200 280" className="w-full max-w-[260px] mx-auto mb-16 block" role="img" aria-label={`${shape} formation diagram`}>
      <rect x="4" y="4" width="192" height="272" rx="4" fill="var(--surface-1)" stroke="var(--border-edge)" />
      <line x1="4" y1="140" x2="196" y2="140" stroke="var(--border-edge)" />
      <circle cx="100" cy="140" r="24" fill="none" stroke="var(--border-edge)" />
      <rect x="55" y="4" width="90" height="36" fill="none" stroke="var(--border-edge)" />
      <rect x="55" y="240" width="90" height="36" fill="none" stroke="var(--border-edge)" />
      <circle cx="100" cy="258" r="7" fill="var(--text-1)" />
      {rows.map((n, i) => Array.from({ length: n }, (_, j) => (
        <circle key={`${i}-${j}`} cx={(200 / (n + 1)) * (j + 1)} cy={rowY(i)} r="7" fill="var(--accent)" />
      )))}
    </svg>
  );
};

const OTHER_LABELS = {
  '/pt': 'Versão Portuguesa',
  '/es': 'Versión en español',
  '/how-to-play': 'How to Play',
  '/features/tactics': 'Tactics & Formations',
  '/features/seasons': 'Seasons & Board',
  '/features/play-with-friends': 'Play with Friends',
};
const labelFor = (to) =>
  [...landingPages, formationsHub, ...formationPages].find((p) => p.path === to)?.breadcrumb
  || blogPosts.find((p) => `/blog/${p.slug}` === to)?.title
  || OTHER_LABELS[to]
  || to;

// Page chrome for the non-English landing pages (English uses FeaturePage's defaults).
const COPY = {
  pt: { related: 'Ver também', ctaTitle: 'Começa a tua carreira', ctaText: 'Cria o teu clube grátis e joga o primeiro jogo já. Sem download.' },
  es: { related: 'Ver también', ctaTitle: 'Empieza tu carrera', ctaText: 'Crea tu club gratis y juega tu primer partido ya. Sin descargas.' },
};

// Renders one entry of src/data/landingPages.js (the prerender reads the same data).
export default function KeywordLanding({ page }) {
  const copy = COPY[page.lang] || {};
  return (
    <FeaturePage
      seo={{ title: page.title, description: page.description, path: page.path, lang: page.lang }}
      eyebrow={page.eyebrow}
      title={page.h1}
      titleAccent={page.h1Accent}
      subtitle={page.subtitle}
      breadcrumbLabel={page.breadcrumb}
      heroContent={page.shape && <FormationPitch shape={page.shape} />}
      sections={[
        ...page.sections.map((s) => ({
          title: s.heading,
          content: <div className="space-y-4 [&_ul]:list-disc [&_ol]:list-decimal [&_ul]:pl-5 [&_ol]:pl-5 [&_li]:mb-2 [&_strong]:text-[var(--text-1)]" dangerouslySetInnerHTML={{ __html: s.html }} />,
        })),
        {
          title: copy.related || 'Related',
          content: (
            <ul className="flex flex-wrap gap-3">
              {page.related.map((to) => (
                <li key={to}>
                  <Link to={to} className="text-[var(--accent)] hover:underline">{labelFor(to)}</Link>
                </li>
              ))}
            </ul>
          ),
        },
      ]}
      faqItems={page.faqs}
      ctaTitle={copy.ctaTitle}
      ctaText={copy.ctaText}
    />
  );
}
